import { makeMultiSearch, makeSearch } from "../../UI/Search/Search";
import PipelineStatusService from "../../../Services/PipelineStatus.service";
const makeSearchArgs = {
    loadOptions: (search, options) => PipelineStatusService.search({
        // @ts-expect-error - TS2345 - Argument of type '{ search: string; options: PipelineStatusSearchArgs; }' is not assignable to parameter of type 'PipelineStatusSearchArgs'.
        search,
        options,
    }),
    label: "name",
    value: "id",
};
export const PipelineSearch = makeSearch(makeSearchArgs);
export const PipelineStatusMultiSearch = makeMultiSearch(makeSearchArgs);
